import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface AuthHistory {
  RmiCompanyId: string,
  RmiEndDate: string | null,
  RmiMemberKeyId: string,
  RmiStartDate: string,
  UserId: string,
  UserRole: number
}

export const postAuthHistory = (member: AuthHistory) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authHistory.isPosting) { return Promise.reject(); }

  dispatch({ type: types.POST_AUTH_HISTORY_REQUEST });

  return api.authorization.history.post(member)
    .then((res: any) => {

      dispatch({
        type: types.POST_AUTH_HISTORY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_AUTH_HISTORY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSpecCodeList = (providerKeyId: any, companyId: any, specialGroupId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SPEC_CODE_LIST_REQUEST });

  return api.authorization.history.getSpecCodeList(providerKeyId, companyId, specialGroupId)
    .then((res: any) => {

      dispatch({
        type: types.GET_SPEC_CODE_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SPEC_CODE_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
